export const APP_CONFIG = {
  showTelephoneWidget: false,
  showPhoneNumber: false,
};
